// servicesData.js

import Image1 from "../Assets/Colrite_files/1.jpg";
import Image2 from "../Assets/Colrite_files/2.jpg";
import Image3 from "../Assets/Colrite_files/3.jpg";
import Image4 from "../Assets/Colrite_files/4.jpg";
import Image5 from "../Assets/Colrite_files/5.jpg";
import Image6 from "../Assets/Colrite_files/6.jpg";
import Image7 from "../Assets/Colrite_files/7.jpg";
import Image8 from "../Assets/Colrite_files/8.jpg";
import Image9 from "../Assets/Colrite_files/9.jpg";
import Image10 from "../Assets/Colrite_files/10.jpg";
import Image11 from "../Assets/Colrite_files/11.jpg";
import Image12 from "../Assets/Colrite_files/12.jpg";
import Image13 from "../Assets/Colrite_files/13.jpg";
import Image14 from "../Assets/Colrite_files/3.jpg";

export const services = [
  {
    title: "AC Installation Services",
    mainImage: Image1,
    bannerImage: Image1,
    description:
      "We provide professional and energy-efficient air conditioning installation services for residential, commercial, and industrial spaces. Our expert technicians ensure proper sizing, safe installation, and optimal system performance to deliver long-lasting comfort and reliability.",
    features: [
      "Accurate load calculation for correct AC capacity selection",
      "Strategic indoor & outdoor unit placement",
      "Secure electrical and refrigerant connections",
      "Complete system testing before handover",
      "Energy-saving guidance and maintenance support"
    ],
    path: "/ac-installation"
  },

  {
    title: "Ductable AC Services",
    mainImage: Image2,
    bannerImage: Image1,
    description:
      "Our ductable air conditioning solutions are ideal for large residential and commercial spaces requiring centralized cooling. We design and install customized duct systems that ensure uniform airflow and superior indoor comfort.",
    features: [
      "Customized duct layout design",
      "Uniform air distribution system",
      "Air balancing for consistent cooling",
      "Energy-efficient system configuration",
      "Preventive maintenance services"
    ],
    path: "/ductable-ac"
  },

  {
    title: "VRV / VRF Services",
    mainImage: Image3,
    bannerImage: Image1,
    description:
      "We specialize in advanced VRV/VRF systems that provide intelligent climate control for multiple zones. These systems ensure high energy efficiency, flexible installation, and independent temperature control for different areas.",
    features: [
      "Multi-zone cooling system design",
      "Advanced inverter-based technology",
      "Independent temperature control",
      "Professional installation & commissioning",
      "Long-term technical support"
    ],
    path: "/vrv-vrf"
  },

  {
    title: "Cassette AC Services",
    mainImage: Image4,
    bannerImage: Image1,
    description:
      "Cassette AC systems are perfect for offices, showrooms, and commercial spaces. We provide professional ceiling-mounted installation ensuring uniform 360-degree airflow and aesthetic integration.",
    features: [
      "Ceiling-mounted space-saving installation",
      "360-degree uniform airflow",
      "Low-noise performance",
      "Ideal for commercial environments",
      "Routine servicing & maintenance"
    ],
    path: "/cassette-ac"
  },

  {
    title: "Chiller AC Services",
    mainImage: Image5,
    bannerImage: Image1,
    description:
      "Our chiller AC systems provide powerful centralized cooling solutions for large commercial and industrial facilities. We ensure efficient operation, reduced energy costs, and reliable long-term performance.",
    features: [
      "High-capacity chiller installation",
      "Centralized cooling management",
      "Energy-efficient operation",
      "Advanced control systems",
      "Performance monitoring & maintenance"
    ],
    path: "/chiller-ac"
  },

  {
    title: "Air Handling Unit (AHU) Services",
    mainImage: Image6,
    bannerImage: Image1,
    description:
      "We design and install Air Handling Units (AHU) that enhance indoor air quality and maintain controlled airflow. Our solutions ensure improved ventilation and energy efficiency.",
    features: [
      "Custom AHU system installation",
      "Airflow optimization",
      "High-efficiency filtration systems",
      "Temperature & humidity control",
      "Scheduled inspection & servicing"
    ],
    path: "/ahu-services"
  },

  {
    title: "Fan Coil Unit (FCU) Services",
    mainImage: Image7,
    bannerImage: Image1,
    description:
      "Our FCU services provide compact and efficient cooling solutions for hotels, offices, and residential buildings. We ensure seamless installation and optimized energy performance.",
    features: [
      "Compact and efficient unit installation",
      "Improved air circulation",
      "Low energy consumption",
      "Silent operation",
      "Maintenance & performance checks"
    ],
    path: "/fcu-services"
  },

  {
    title: "Package AC Services",
    mainImage: Image8,
    bannerImage: Image1,
    description:
      "Package AC systems are complete all-in-one cooling solutions suitable for large commercial areas. We deliver reliable installation, testing, and ongoing support services.",
    features: [
      "All-in-one cooling system setup",
      "Ideal for malls & auditoriums",
      "Heavy-duty commercial performance",
      "Energy optimization solutions",
      "Full testing & commissioning"
    ],
    path: "/package-ac"
  },

  {
    title: "Plumbing Services",
    mainImage: Image9,
    bannerImage: Image1,
    description:
      "We provide comprehensive plumbing services including installation, repair, and maintenance. Our expert team ensures efficient water flow and leak-free systems.",
    features: [
      "Pipeline installation & layout",
      "Leak detection & repair",
      "Bathroom & kitchen plumbing",
      "Water pressure optimization",
      "Emergency maintenance support"
    ],
    path: "/plumbing"
  },

  {
    title: "Drainage System Services",
    mainImage: Image10,
    bannerImage: Image1,
    description:
      "Our drainage system solutions ensure smooth wastewater management and prevent water stagnation issues through professional design and installation.",
    features: [
      "Drainage system planning & design",
      "Quality pipe installation",
      "Clog removal services",
      "Stormwater management",
      "Repair & maintenance support"
    ],
    path: "/drainage-system"
  },

  {
    title: "Fire Fighting Services",
    mainImage: Image11,
    bannerImage: Image1,
    description:
      "We install complete fire protection systems to safeguard lives and property. Our solutions comply with safety standards and ensure emergency readiness.",
    features: [
      "Fire hydrant & sprinkler installation",
      "Fire alarm system setup",
      "Safety compliance & certification",
      "Emergency system testing",
      "Routine inspection services"
    ],
    path: "/fire-fighting"
  },

  {
    title: "Electrical Services",
    mainImage: Image12,
    bannerImage: Image1,
    description:
      "We offer reliable electrical installation and maintenance services ensuring safe and uninterrupted power supply for residential and commercial spaces.",
    features: [
      "Complete wiring installation",
      "Electrical panel setup",
      "Safety inspections",
      "Fault detection & troubleshooting",
      "Energy-efficient solutions"
    ],
    path: "/electrical-services"
  },

  {
    title: "Welding Services",
    mainImage: Image13,
    bannerImage: Image1,
    description:
      "Our professional welding services include fabrication, repair, and structural reinforcement for industrial and commercial applications.",
    features: [
      "Precision metal fabrication",
      "Structural welding solutions",
      "Repair & reinforcement",
      "Advanced welding equipment",
      "Strict quality & safety standards"
    ],
    path: "/welding-services"
  },

  {
    title: "Bill of Quantities (BOQ) Services",
    mainImage: Image14,
    bannerImage: Image1,
    description:
      "We provide accurate and detailed Bill of Quantities (BOQ) services to support budgeting, cost estimation, and project planning for construction projects.",
    features: [
      "Detailed quantity take-offs",
      "Material cost estimation",
      "Budget forecasting",
      "Transparent documentation",
      "Project planning support"
    ],
    path: "/boq-services"
  }
];